import { render, staticRenderFns } from "./NursePatientTreatmentList.vue?vue&type=template&id=3b3e3a71&"
import script from "./NursePatientTreatmentList.vue?vue&type=script&lang=js&"
export * from "./NursePatientTreatmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports